import Link from 'next/link';
import { type JSX } from 'react';

/**
 * Inline card shown in the chat pane when a browse user has reached
 * the conversational search message limit.
 */
export function UsageLimitMessage(): JSX.Element {
    return (
        <div className="flex flex-col gap-2 rounded-t-2xl border-x border-t border-yellow-400 bg-yellow-50 px-6 pt-4 pb-2">
            <p className="text-base font-bold text-amber-700">Usage limit reached</p>
            <p className="text-sm text-gray-900">
                Upgrade to access more enhanced search, plus get unlimited downloads and access to creative tools
            </p>
            <Link
                href="/pricing"
                data-cta="conv_search_prompt"
                className="flex w-full items-center justify-center rounded-lg bg-yellow-300 px-6 py-2.5 text-sm font-semibold text-gray-900 hover:bg-yellow-400 transition-colors"
            >
                Upgrade to continue
            </Link>
        </div>
    );
}
